/* unplugin-vue-components disabled */import { render } from "./c-carousel.vue?vue&type=template&id=5cc26e7d&scoped=true"
import script from "./c-carousel.vue?vue&type=script&lang=js"
export * from "./c-carousel.vue?vue&type=script&lang=js"

import "./c-carousel.vue?vue&type=style&index=0&id=5cc26e7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc26e7d"]])

export default __exports__